var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "columns p-3 m-0" }, [
    _c("div", { staticClass: "column p-0 m-0" }, [
      _c(
        "div",
        { staticClass: "columns is-vcentered p-0 m-0 pb-2 bb-grey-1" },
        [
          _c(
            "div",
            { staticClass: "column p-0 m-0 is-size-6 is-6" },
            [_vm._t("heading")],
            2
          ),
          _c("div", { staticClass: "column p-0 m-0" }, [
            _c(
              "div",
              { staticClass: "is-flex is-flex-direction-row-reverse" },
              [_vm._t("heading_buttons")],
              2
            ),
          ]),
        ]
      ),
      _c("div", { staticClass: "columns p-0 m-0" }, [
        _c("div", { staticClass: "column p-0 m-0" }, [_vm._t("body")], 2),
      ]),
      _c("div", { staticClass: "columns p-0 m-0 pt-2" }, [
        _c("div", { staticClass: "column p-0 m-0" }, [_vm._t("footer")], 2),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }